import React, { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

const ACTIONS = ["", "clock_in", "clock_in_failed", "clock_out", "correction_approved", "correction_declined", "assignment_created", "assignment_updated", "assignment_deleted"];

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [action, setAction] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get("/audit-log", { params: action ? { action } : {} });
      setItems(data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };
  useEffect(() => { load(); }, [action]); // eslint-disable-line

  return (
    <div className="px-4 md:px-10 py-8 max-w-7xl mx-auto" data-testid="audit-log-page">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <div className="label-eyebrow">Security</div>
          <h1 className="font-heading font-black text-4xl tracking-tighter text-zinc-950 mt-1">Audit Log</h1>
          <p className="text-zinc-600 mt-1 text-sm">Every clock-in attempt, correction, and admin action is recorded here.</p>
        </div>
        <div>
          <label className="label-eyebrow block mb-1.5">Filter by action</label>
          <select value={action} onChange={(e) => setAction(e.target.value)} className="lom-input min-w-[220px]" data-testid="audit-action-filter">
            {ACTIONS.map((a) => <option key={a || "all"} value={a}>{a || "All actions"}</option>)}
          </select>
        </div>
      </div>

      <div className="bg-white border border-zinc-200 rounded-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 border-b border-zinc-200">
            <tr>
              <Th>When</Th><Th>Actor</Th><Th>Action</Th><Th>OK?</Th><Th>Target</Th><Th>Meta</Th><Th>IP</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-100">
            {items.length === 0 && (
              <tr><td colSpan={7} className="text-center text-zinc-500 py-10">No entries</td></tr>
            )}
            {items.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`}>
                <Td className="font-mono text-xs whitespace-nowrap">
                  {r.created_at ? new Date(r.created_at).toLocaleString([], { dateStyle: "short", timeStyle: "medium" }) : "—"}
                </Td>
                <Td>
                  <div className="font-semibold text-zinc-950">{r.actor_name || "—"}</div>
                  <div className="text-xs text-zinc-500 capitalize">{r.actor_role || "—"}</div>
                </Td>
                <Td>
                  <span className="font-mono text-xs px-2 py-0.5 bg-zinc-100 rounded-sm">{r.action}</span>
                </Td>
                <Td>
                  {r.ok
                    ? <span className="text-emerald-700 font-bold text-xs">OK</span>
                    : <span className="text-red-700 font-bold text-xs">FAIL</span>}
                </Td>
                <Td className="font-mono text-xs text-zinc-500">{r.target_type || "—"}</Td>
                <Td>
                  {r.meta && Object.keys(r.meta).length > 0 ? (
                    <div className="text-xs font-mono text-zinc-600 max-w-md">
                      {Object.entries(r.meta).map(([k, v]) => (
                        <div key={k}><span className="text-zinc-400">{k}:</span> {typeof v === "object" ? JSON.stringify(v) : String(v)}</div>
                      ))}
                    </div>
                  ) : "—"}
                </Td>
                <Td className="font-mono text-xs text-zinc-500">{r.ip || "—"}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Th = ({ children, className = "" }) => (
  <th className={`px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-zinc-500 ${className}`}>{children}</th>
);
const Td = ({ children, className = "" }) => (
  <td className={`px-4 py-3 text-zinc-900 align-top ${className}`}>{children}</td>
);
